import defaultsTranslations from './defaults';
const localeTranslations = {
    ...defaultsTranslations,
};
export default localeTranslations;
